import { Controller } from 'stimulus'
import './component.scss'

window.Stimulus.register(
  'area-search-modal',
  class extends Controller {
    static targets = [
      'modal',
      'content',
      'overlay',
      'cityTitle',
      'prefectureTitle',
      'regionName',
      'prefectureName',
      'cityArrow',
      'cityName',
      'citiesSlide',
      'prefecturesSlide',
      'cityList',
      'cityFooter',
      'prefectureFooter'
    ]

    static values = {
      currentSlide: String
    }

    static CLASSES = {
      SLIDE_TO_PREFECTURES: 'slide-to-prefectures',
      ACTIVE_CONTENT: 'area-search-modal__content--active',
      ACTIVE_OVERLAY: 'area-search-modal__overlay--active',
      SELECTED_CITY: 'area-search-modal__city-item--selected',
      SELECTED_PREFECTURE: 'area-search-modal__prefecture-item--selected'
    }

    connect() {
      this.currentSlideValue = 'cities'
      this._initializeSelectedPrefecture()
    }

    openModal() {
      if (!this.hasContentTarget || !this.hasOverlayTarget) return

      this._setBodyOverflow('hidden')
      this._toggleModalVisibility(true)
    }

    closeModal() {
      if (!this.hasContentTarget || !this.hasOverlayTarget) return

      this._setBodyOverflow('')
      this._toggleModalVisibility(false)
    }

    toggleCitySelection(event) {
      const cityItem = event.currentTarget
      const isAlreadySelected = cityItem.classList.contains(this.constructor.CLASSES.SELECTED_CITY)

      this._clearAllCitySelections()

      if (!isAlreadySelected) {
        cityItem.classList.add(this.constructor.CLASSES.SELECTED_CITY)
        this._updateBreadcrumb(cityItem.textContent.trim())
      } else {
        this._updateBreadcrumb(null)
      }
    }

    async togglePrefectureSelection(event) {
      const prefectureItem = event.currentTarget
      const isAlreadySelected = prefectureItem.classList.contains(this.constructor.CLASSES.SELECTED_PREFECTURE)

      if (isAlreadySelected) {
        return
      }

      this._updatePrefectureSelection(prefectureItem)
      await this._handlePrefectureChange()
    }

    showPrefectureSelection() {
      this._updateBreadcrumb(null)
      this._toggleSlides(true)
      this._toggleTitles(false)
      this._toggleFooters(false)

      if (this.selectedRegionId) {
        this._scrollToRegion(this.selectedRegionId)
      }

      this.currentSlideValue = 'prefectures'
    }

    performSearch() {
      const prefectureName = this.selectedPrefectureName || this.modalTarget.dataset.prefectureName
      const partTypeUrl = this.modalTarget.dataset.partTypeUrl

      const url = this._buildSearchUrl(prefectureName, partTypeUrl)
      window.location.href = url
    }

    selectCityView() {
      this._showCitySelection()
    }

    // Private methods

    _initializeSelectedPrefecture() {
      if (!this.hasModalTarget) return

      this.selectedPrefectureName = this.modalTarget.dataset.prefectureName
      this.selectedPrefectureId = null

      const selectedItem = this.element.querySelector(`.${this.constructor.CLASSES.SELECTED_PREFECTURE}`)
      if (selectedItem) {
        this.selectedRegionId = selectedItem.dataset.regionId
        this.selectedPrefectureId = selectedItem.dataset.prefectureId
        this.selectedRegionName = selectedItem.dataset.regionName
      } else {
        this.selectedRegionId = null
        this.selectedRegionName = null
      }
    }

    _setBodyOverflow(value) {
      document.body.style.overflow = value
    }

    _toggleModalVisibility(isActive) {
      const action = isActive ? 'add' : 'remove'
      this.contentTarget.classList[action](this.constructor.CLASSES.ACTIVE_CONTENT)
      this.overlayTarget.classList[action](this.constructor.CLASSES.ACTIVE_OVERLAY)
    }

    _clearAllCitySelections() {
      const allCityItems = this.element.querySelectorAll('.area-search-modal__city-item')
      allCityItems.forEach(item => {
        item.classList.remove(this.constructor.CLASSES.SELECTED_CITY)
      })
    }

    _updateBreadcrumb(cityName) {
      const displayValue = cityName ? '' : 'none'
      this.cityNameTarget.textContent = cityName || ''
      this.cityArrowTarget.style.display = displayValue
      this.cityNameTarget.style.display = displayValue
    }

    _updateBreadcrumbPrefecture(regionName, prefectureName) {
      this.regionNameTarget.textContent = regionName
      this.prefectureNameTarget.textContent = prefectureName
    }

    _buildSearchUrl(prefectureName, partTypeUrl) {
      let url = `/area/${encodeURIComponent(prefectureName)}`

      if (this.currentSlideValue === 'cities') {
        url += this._buildCityUrlPath(partTypeUrl)
      } else {
        url += `/part/${encodeURIComponent(partTypeUrl)}`
      }

      return this._appendQueryParams(url)
    }

    _buildCityUrlPath(partTypeUrl) {
      const selectedCityItem = this.element.querySelector(`.${this.constructor.CLASSES.SELECTED_CITY}`)
      const cityId = selectedCityItem ? selectedCityItem.dataset.cityId : null

      if (cityId) {
        return `/${encodeURIComponent(cityId)}/${encodeURIComponent(partTypeUrl)}`
      }
      return `/part/${encodeURIComponent(partTypeUrl)}`
    }

    _appendQueryParams(url) {
      const currentParams = new URLSearchParams(window.location.search)
      if (currentParams.toString()) {
        return `${url}?${currentParams.toString()}`
      }
      return url
    }

    _updatePrefectureSelection(prefectureItem) {
      this._clearAllPrefectureSelections()
      prefectureItem.classList.add(this.constructor.CLASSES.SELECTED_PREFECTURE)

      this.selectedPrefectureId = prefectureItem.dataset.prefectureId
      this.selectedPrefectureName = prefectureItem.dataset.prefectureName
      this.selectedRegionName = prefectureItem.dataset.regionName
      this.selectedRegionId = prefectureItem.dataset.regionId
    }

    _clearAllPrefectureSelections() {
      const allPrefectureItems = this.element.querySelectorAll('.area-search-modal__prefecture-item')
      allPrefectureItems.forEach(item => {
        item.classList.remove(this.constructor.CLASSES.SELECTED_PREFECTURE)
      })
    }

    async _handlePrefectureChange() {
      const initialPrefectureName = this.modalTarget.dataset.prefectureName

      if (this.selectedPrefectureName === initialPrefectureName) {
        return
      }

      this._updateBreadcrumbPrefecture(this.selectedRegionName, this.selectedPrefectureName)
      this._clearCitySelection()

      try {
        const cities = await this._fetchCities(this.modalTarget.dataset.partTypeUrl)
        this._updateCityList(cities)
        this.modalTarget.dataset.prefectureName = this.selectedPrefectureName
      } catch (error) {
        console.error('API呼び出しエラー:', error)
      }
    }

    async _fetchCities(partTypeUrl) {
      const url = `/api/prefecture/${encodeURIComponent(this.selectedPrefectureName)}/enable_cities_for_part_type?part_type_url=${encodeURIComponent(partTypeUrl)}`
      const response = await fetch(url)

      if (!response.ok) {
        throw new Error('市区町村データの取得に失敗しました')
      }

      return await response.json()
    }

    _showCitySelection() {
      this._scrollCitiesToTop()
      this._toggleSlides(false)
      this._toggleTitles(true)
      this._toggleFooters(true)

      this.currentSlideValue = 'cities'
    }

    _toggleSlides(toPrefectures) {
      const action = toPrefectures ? 'add' : 'remove'
      this.citiesSlideTarget.classList[action](this.constructor.CLASSES.SLIDE_TO_PREFECTURES)
      this.prefecturesSlideTarget.classList[action](this.constructor.CLASSES.SLIDE_TO_PREFECTURES)
    }

    _toggleTitles(showCityTitle) {
      this.cityTitleTarget.style.display = showCityTitle ? '' : 'none'
      this.prefectureTitleTarget.style.display = showCityTitle ? 'none' : ''
    }

    _toggleFooters(showCityFooter) {
      this.cityFooterTarget.style.display = showCityFooter ? '' : 'none'
      this.prefectureFooterTarget.style.display = showCityFooter ? 'none' : ''
    }

    _scrollCitiesToTop() {
      const citiesBody = this.citiesSlideTarget.querySelector('.area-search-modal__body')
      if (citiesBody) {
        citiesBody.scrollTop = 0
      }
    }

    _updateCityList(cities) {
      this.cityListTarget.innerHTML = ''

      const enabledCities = cities.filter(city => city.enabled)
      enabledCities.forEach(city => {
        const cityItem = this._createCityItem(city)
        this.cityListTarget.appendChild(cityItem)
      })
    }

    _createCityItem(city) {
      const cityItem = document.createElement('div')
      cityItem.className = 'area-search-modal__city-item'
      cityItem.dataset.action = 'click->area-search-modal#toggleCitySelection'
      cityItem.dataset.cityId = city.id
      cityItem.textContent = city.name
      return cityItem
    }

    _clearCitySelection() {
      this._clearAllCitySelections()
      this._updateBreadcrumb(null)
    }

    _scrollToRegion(regionId) {
      const targetRegion = this.element.querySelector(`.area-search-modal__region-section[data-region-id="${regionId}"]`)

      if (targetRegion) {
        const slideRect = this.prefecturesSlideTarget.getBoundingClientRect()
        const targetRect = targetRegion.getBoundingClientRect()
        const relativeTop = targetRect.top - slideRect.top + this.prefecturesSlideTarget.scrollTop

        this.prefecturesSlideTarget.scrollTop = relativeTop
      }
    }
  }
)
